import { render, staticRenderFns } from "./PrintBargeSaham.vue?vue&type=template&id=cbf7e7ee&scoped=true&"
import script from "./PrintBargeSaham.vue?vue&type=script&lang=js&"
export * from "./PrintBargeSaham.vue?vue&type=script&lang=js&"
import style0 from "./PrintBargeSaham.vue?vue&type=style&index=0&id=cbf7e7ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf7e7ee",
  null
  
)

export default component.exports